import {
  CREDIT_REDEMPTION_REQUEST,
  CREDIT_REDEMPTION_SUCCESS,
  CREDIT_REDEMPTION_FAILURE,
} from '../actions/types';

const initialState = {
  loading: false,
  error: undefined,
};

export default function creditRedemptionReducer(state = initialState, action = {}) {
  switch (action.type) {
    case CREDIT_REDEMPTION_REQUEST:
      return {
        ...state,
        show: false,
        loading: true,
      };
    case CREDIT_REDEMPTION_SUCCESS: {
      const {
        success,
        title,
        body,
        buttons,
        breakdown_buttons: breakdownButtons,
        details,
      } = action.payload;

      return {
        ...state,
        show: true,
        loading: false,
        success,
        title,
        body,
        buttons,
        breakdownButtons,
        details,
        error: undefined,
      };
    }
    case CREDIT_REDEMPTION_FAILURE:
      return {
        ...state,
        show: false,
        loading: false,
        error: {
          status: action.status,
        },
      };
    default:
      return state;
  }
}
